import Blockquote from '@tiptap/extension-blockquote';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Code from '@tiptap/extension-code';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';

export const createEditorConfig = (placeholder: string) => ({
  extensions: [
    StarterKit.configure({
      paragraph: false,
      bold: false,
      bulletList: false,
      orderedList: false,
      blockquote: false,
      code: false,
      hardBreak: false,
      heading: false,
      horizontalRule: false,
    }),
    Placeholder.configure({
      placeholder,
      emptyEditorClass: 'is-editor-empty',
      emptyNodeClass: 'is-empty',
      showOnlyWhenEditable: true,
      showOnlyCurrent: false,
    }),
    Paragraph.configure({
      HTMLAttributes: {
        class: 'leading-none my-[10px]',
      },
    }),
    Bold.configure({
      HTMLAttributes: {
        class: 'font-bold',
      },
    }),
    Underline,
    Link.configure({
      HTMLAttributes: {
        class:
          'inline-flex items-center gap-x-1 text-blue-500 decoration-2 hover:underline font-medium',
      },
    }),
    BulletList.configure({
      HTMLAttributes: {
        class: 'list-disc list-inside text-neutral-800',
      },
    }),
    OrderedList.configure({
      HTMLAttributes: {
        class: 'list-decimal list-inside text-neutral-800',
      },
    }),
    Blockquote.configure({
      HTMLAttributes: {
        class: 'text-neutral-800 sm:text-xl border-l-4 border-neutral-300 pl-4 my-4',
      },
    }),
    Code,
    HardBreak.configure({
      keepMarks: true,
      HTMLAttributes: {
        class: 'my-2',
      },
    }),
    Heading.configure({
      levels: [1, 2, 3],
      HTMLAttributes: {
        class: 'font-bold',
      },
    }),
    HorizontalRule.configure({
      HTMLAttributes: {
        class: 'my-4 border-t border-neutral-300',
      },
    }),
    Image.configure({
      inline: false,
      allowBase64: true,
      HTMLAttributes: {
        class: 'max-w-full rounded my-2',
      },
    }),
  ],
  editorProps: {
    attributes: {
      class:
        'w-full px-3 py-2 border border-neutral-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
      style: 'min-height: 280px; resize: none; line-height: 0.75rem; padding-top: 0.75rem',
    },
  },
});
